"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function DarkModeFilledIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M16.2,7.883a11.87,11.87,0,0,1-5.533,10.046,6.44,6.44,0,0,0,5.491-11Q16.2,7.407,16.2,7.883Z" }),
        react_1.default.createElement("path", { d: "M19.7.024H4.3A4.279,4.279,0,0,0,.024,4.3V19.7A4.28,4.28,0,0,0,4.3,23.976H19.7A4.28,4.28,0,0,0,23.976,19.7V4.3A4.279,4.279,0,0,0,19.7.024ZM6.145,10.721,6.47,8.826,5.093,7.485,7,7.208l.85-1.724L8.7,7.208l1.9.277L9.223,8.826l.325,1.895-1.7-.895Zm12.7,4.385a7.922,7.922,0,0,1-7.113,4.443A8.02,8.02,0,0,1,8.363,18.8a.765.765,0,0,1,.02-1.4A10.346,10.346,0,0,0,14.67,7.883a10.444,10.444,0,0,0-.31-2.474.764.764,0,0,1,1.1-.856A7.931,7.931,0,0,1,18.844,15.106Z" })));
}
exports.default = DarkModeFilledIcon;
